import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export const headingSweep = () => {

	const strings = document.querySelectorAll('[data-animation="heading-sweep"]')

	if (!strings.length || window.innerWidth < 1000) return false

	strings.forEach(string => {

		let split = new SplitText(string, {
			type: 'lines',
			preserveSpaces: true,
		})

		string.removeAttribute('aria-label')

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: string.parentElement,
				// pin: true,
				start: 'top 80%',
				end: 'center center',
				ease: 'none',
				scrub: 3,
				// markers: true,
			}
		})

		split.lines.forEach(line => {
			tl.fromTo(line, {
				clipPath: 'polygon(0 -15%, 0 -15%, 0 115%, 0 115%)',
			}, {
				clipPath: 'polygon(0 -15%, 100% -15%, 100% 115%, 0 115%)',
			})
		})

	})
}

export default () => { }